module.exports = __webpack_public_path__ + "img/hungary.222f583f.png";